"use client"

import { Box, styled, Theme, useMediaQuery } from "@mui/material"
import React from "react"
import { mediaQueries, sharedTheme, sizes } from "../theme/theme"
import BulletCard, { BulletCardItem } from "./BulletCard"

interface BulletsCardsListProps {
  itemsList: BulletCardItem[]
  buttonVariant?: "elevated" | "outlined" | undefined
  onButtonClick?: (item: BulletCardItem, categoryName?: string) => void
  categoryName?: string
}

const StyledBulletCardList = styled(Box)`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  align-items: stretch;
  gap: ${sizes.baseTriple};
  max-width: 1800px;
  overflow: visible;
  ${mediaQueries.tablet} {
    height: unset;
  }
  ${mediaQueries.desktopM} {
    height: unset;
  }
`

const BulletsCardsList: React.FC<BulletsCardsListProps> = ({
  itemsList,
  buttonVariant,
  onButtonClick,
  categoryName,
}) => {
  const isMediumDesktop = useMediaQuery<Theme>(
    sharedTheme.breakpoints.up("laptop"),
  )
  const removeHeight = isMediumDesktop ? itemsList?.length > 3 : true
  return (
    <StyledBulletCardList>
      {itemsList &&
        itemsList.map((item, index) => {
          return (
            <BulletCard
              key={`bullet-card-list-item-${index}-${item?.title?.value}`}
              item={item}
              buttonVariant={buttonVariant}
              onButtonClick={onButtonClick}
              categoryName={categoryName}
              cardHeight={removeHeight ? "unset" : undefined}
            />
          )
        })}
    </StyledBulletCardList>
  )
}

export default BulletsCardsList
